/* This file is automatically generated on build. Changes will be overwritten */
export default ["/uvery/","/ng/en/get-a-loan/"];